import { SearchStoreState } from '~/domain/interfaces/SearchTypes'

export default {
  term: (state: SearchStoreState) => state.term,
  filter: (state: SearchStoreState) => state.filter,
}
